
import React from "react";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

export const ChatHeadSkeleton = () => {
    return (
        <React.Fragment>
            <div className="contact-profile">
				<div className="user-detail">
					<a href="javascript:void(0)" className="cx-btn-chat"><i className="ri-add-line"></i></a>
					<img src={`${process.env.PUBLIC_URL}/assets/image/user.png`} alt="user" />
					<div className="name">
						<p style={{width:'100px'}}><Skeleton rect={true} count={1} width="100%" height={18} /></p>
						<span className="online"></span>
					</div>
				</div>
			</div>
        </React.Fragment>
    );
};

export const ChatMessageSkeleton = () => {
	return (
		<React.Fragment>
			<ul>
				<li className="replies">
					<Skeleton circle={true} width={25} height={25} />&nbsp;&nbsp;
			        <Skeleton rect={true} count={1} width={500} height={60} baseColor="#ebebeb" highlightColor="#f5f5f5"/>
				</li>
				<li className="sent">
					<Skeleton circle={true} width={25} height={25} />&nbsp;&nbsp;
			        <Skeleton rect={true} count={1} width={500} height={60} baseColor="#54d3c2" highlightColor="#f5f5f5"/>
				</li>
				<li className="replies">
					<Skeleton circle={true} width={25} height={25} />&nbsp;&nbsp;
			        <Skeleton rect={true} count={1} width={500} height={60} baseColor="#ebebeb" highlightColor="#f5f5f5"/>
				</li>
				<li className="sent">
					<Skeleton circle={true} width={25} height={25} />&nbsp;&nbsp;
			        <Skeleton rect={true} count={1} width={500} height={60} baseColor="#54d3c2" highlightColor="#f5f5f5"/>
				</li>
			</ul>
		</React.Fragment>
	);
}